import { useState, type FormEvent } from 'react'
import { changePassword } from '../api'
import { useAuth } from '../auth'

export default function Account() {
  const { user, signOut } = useAuth()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [message, setMessage] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError(null)
    setMessage(null)

    if (next !== confirm) {
      setError('새 비밀번호가 서로 다릅니다')
      return
    }

    try {
      await changePassword(current, next)
      setMessage('비밀번호를 변경했습니다. 다시 로그인해주세요.')
      // The server dropped every session, so the local one is dead too.
      setTimeout(() => void signOut(), 1500)
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err))
    }
  }

  return (
    <div className="pad narrow">
      <h1>계정</h1>
      <dl className="facts">
        <div>
          <dt>이름</dt>
          <dd>{user?.displayName}</dd>
        </div>
        <div>
          <dt>아이디</dt>
          <dd>{user?.email}</dd>
        </div>
        <div>
          <dt>역할</dt>
          <dd>{user?.role === 'admin' ? '관리자' : '사용자'}</dd>
        </div>
      </dl>

      <h2>비밀번호 변경</h2>
      <form onSubmit={submit} className="stack">
        <label>
          현재 비밀번호
          <input
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(event) => setCurrent(event.target.value)}
            required
          />
        </label>
        <label>
          새 비밀번호 (8자 이상)
          <input
            type="password"
            autoComplete="new-password"
            minLength={8}
            value={next}
            onChange={(event) => setNext(event.target.value)}
            required
          />
        </label>
        <label>
          새 비밀번호 확인
          <input
            type="password"
            autoComplete="new-password"
            minLength={8}
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            required
          />
        </label>
        {error && <p className="error">{error}</p>}
        {message && <p className="success">{message}</p>}
        <button type="submit" className="primary">
          변경
        </button>
      </form>
    </div>
  )
}
